export default __webpack_public_path__ + "f2482280c1f4f195e18e2ed6062c021d.png";